import React, {useEffect, createRef} from 'react'
import './landing.css'
import AnimateLoad from 'components/common/animate-load'
import Tile from './components/tile.js'
import {connect, useDispatch} from 'react-redux'
import Tiles from './tile.json.js'
import {gsap} from 'gsap/dist/gsap'
import {Slide} from 'react-slideshow-image'
import {setSearchOptions, setPagingSetting} from '../../redux/actions/index'
import 'react-slideshow-image/dist/styles.css'
import Button from "../../components/common/buttons/link-button-icon";
import {AU} from 'utils/constants'

const Landing = (props) => {
    const dispatch = useDispatch()

    const {
        isAccountAccessLoading,
        isAccountDetailsLoading,
        memberInfo,
        isNZ
    } = props

    const slideImages = [
        {
            title: 'A New Era in Printer Technology',
            caption: "Discover Canon\'s imageFORCE range, combining OLED-powered image quality with enterprise-grade security for vibrant, precise, and protected printing.",
            url: '/assets/img/2025-landing-hero.png',
            buttonLink: isNZ ? 'https://www.canon.co.nz/business/imageforce' : 'https://www.canon.com.au/business/imageforce',
            buttonCaption: 'Learn more',
            customStyles: {backgroundSize: 'auto 100%'}
        },
        {
            title: 'Welcome to MyCanon Business',
            caption: "Your Business, Your Time, Your Way",
            url: '/assets/img/landing-page-hero.jpg',
            customStyles: {backgroundSize: 'cover'}
        }
    ]


    const handleSetOptionsData = () => {
        const payload = {}
        dispatch(setSearchOptions(payload))
        dispatch(setPagingSetting(payload))
    }
    // cards, elements tha will be used in the tween
    let cards = []

    // the timeline instance
    const tl = gsap.timeline()

    //MH- test tween
    const tweenRestart = () => {
        const myRef = '.tile-101'
        tl.to(
            myRef,
            0.6,
            {
                stagger: {
                    autoAlpha: 1,
                    y: -20,
                    ease: 'easeInOut',
                    onComplete: null
                },
                delay: 2
            },
            0.1
        ).restart()
    }


    useEffect(
        () => {
            if (
                !cards ||
                cards.length <= 0 ||
                isAccountDetailsLoading ||
                isAccountAccessLoading
            ) return

            handleSetOptionsData()

            tl.to(
                '.tile-101',
                0.6,
                {
                    stagger: {
                        autoAlpha: 1,
                        y: -20,
                        ease: 'easeInOut',
                        onComplete: null
                    }
                },
                0.1
            ).play()
        },
        [isAccountAccessLoading, isAccountDetailsLoading, cards]
    )


    return (
        <div className="mcb__landing">
            <Slide duration={8000}>
                {slideImages.map(({id, title, caption, buttonCaption, buttonLink, customStyles, url}, index) => (
                    <div className="landing-hero" style={{backgroundImage: `url(${url})`, ...customStyles}}
                         key={index}>
                        <div>
                            <div className="heading d-flex-jc d-flex-dir-c">
                                <div className="">
                                    <h1 className="fs-bigy fs-headline ma-0">
                                        {title}
                                    </h1>
                                    <div className="fs-headliney fs-title ma-0 pt-8">
                                        {caption}
                                    </div>
                                    {(buttonCaption && buttonLink) && (
                                        <div className='buttonContainer'>
                                            <Button
                                                btnClass="btn__7"
                                                onClick={() => window.open(buttonLink, '_blank')}
                                                btnText={buttonCaption}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slide>

            <div
                className="section-layout-1200 tiles-container d-flex-jsb"
                style={{
                    flexWrap: 'wrap',
                    filter:
                        isAccountDetailsLoading && isAccountAccessLoading
                            ? 'blur(3px)'
                            : 'none',
                    pointerEvents:
                        isAccountDetailsLoading && isAccountAccessLoading
                            ? 'none'
                            : 'inherit'
                }}
            >
                {Object.keys(Tiles).map(key => {
                    let permissions = new Set()
                    Tiles[key].links.forEach(link => {
                        if (link.permissions)
                            link.permissions.forEach(permission => {
                                permissions.add(permission)
                            })
                    })

                    return (
                        <Tile
                            title={Tiles[key].title}
                            icon={Tiles[key].icon}
                            links={Tiles[key].links}
                            toolTip={Tiles[key].toolTip}
                            metadata={{
                                permissions: [...permissions]
                            }}
                            memberInfo={memberInfo}
                            root={props.match.params.id}
                            key={Tiles[key].title}
                            ref={(cards[key] = createRef(div => div))}
                            isNZ={isNZ}
                        />
                    )
                })}
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    const isAccountDetailsLoading = state?.canonhub?.accountDetails?.loading
    const isAccountAccessLoading = state?.canonhub?.accountAccess?.loading
    const isNZ = state?.canonhub?.accountDetails?.data?.Localization !== AU
    const memberInfo = state?.canonhub?.memberInfo

    return {
        isAccountDetailsLoading,
        isAccountAccessLoading,
        isNZ,
        memberInfo
    }
}

export default connect(
    mapStateToProps,
    null
)(AnimateLoad(Landing))
